import React from "react";
import { FaQuestion } from "react-icons/fa";

export default function TooltipIcon(props) {

  return (
    <>
      <div className="icon-button">
        <FaQuestion/>
      </div>
    </>
  );
}
